<div class="body-wrapper main-wrapper">
    <ng-container *ngIf="showAppHeaderFooter">
      <aa-header></aa-header>
    </ng-container>
    <router-outlet></router-outlet>
</div>
